export const ceaProfileFilterPayload = {
  filters: {
    startDate: {
      date: [],
      operator: ">",
    },
    endDate: {
      date: [],
      operator: "<",
    },
    fileNames: [],
    uploadedDate: {
      date: [],
      operator: "=",
    },
    fileSize: {
        operator: "",
        params: []
    },
    isDownloaded: [],
  },
};
